import { ReactNode } from 'react';

export default function BodyLayout({ children }: { children: ReactNode }) {
	return (
		<div
			className="flex grow flex-col w-full h-full bg-[100%_auto] bg-no-repeat 
				bg-[url('@assets/images/background/background-mobile.svg')] 
				tablet:bg-[url('@assets/images/background/background-tablet.svg')] 
				desktop:bg-[url('@assets/images/background/background.svg')] relative">
			<div className='desktop:container flex grow flex-col'>{children}</div>
		</div>
	);
}
